export enum ProductEnum {

  TESTDAF = 'TESTDAF',
  TESTAS = 'TESTAS',
  DMAT = 'DMAT',
  DTZ = 'DTZ',
}
